"use strict";

var _interopRequireDefault = require("/www/wwwroot/check/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es7.string.pad-start");
var _request = _interopRequireDefault(require("@/utils/request"));
var _request2 = _interopRequireDefault(require("@/utils/request4"));
var _RestTable = _interopRequireDefault(require("@/components/RestTable.vue"));
var _index = _interopRequireDefault(require("@/components/Pagination/index.vue"));
var _formatMixin = require("@/utils/formatMixin");
var _fileSaver = _interopRequireDefault(require("file-saver"));
var _default = exports.default = {
  components: {
    RestTable: _RestTable.default,
    Pagination: _index.default
  },
  mixins: [_formatMixin.formatMixin],
  data: function data() {
    return {
      // 顶部搜索框form数据
      formInline: {
        card_code: '',
        //搜索关键词
        real_name: '',
        mobile: '',
        type: '1,2,3,4,5,6,7,8,9,10,11,12,13,14,15,16,17,18',
        start_time: '',
        end_time: ''
      },
      //   dialogVisiblerisk: false,
      datenum: [],
      money: 0,
      // 商家余额
      moneyList: {
        count: 0
      },
      // 划扣流水
      listQuery: {
        page: 1,
        page_size: 10
      },
      listLoading: false,
      riskform: {
        real_name: '',
        card_code: '',
        mobile: ''
      }
    };
  },
  created: function created() {
    this.getMoneyList();
  },
  computed: {
    start_time: function start_time() {
      return this.datenum[0] ? this.formatDate(this.datenum[0]) : '';
    },
    end_time: function end_time() {
      return this.datenum[1] ? this.formatDate(this.datenum[1]) : '';
    }
  },
  methods: {
    // 格式化日期,需要加上时分秒的数据
    formatDate: function formatDate(date) {
      var year = date.getFullYear();
      var month = String(date.getMonth() + 1).padStart(2, '0'); // 月份从0开始，所以要加1
      var day = String(date.getDate()).padStart(2, '0');
      var hour = String(date.getHours()).padStart(2, '0');
      var minute = String(date.getMinutes()).padStart(2, '0');
      var second = String(date.getSeconds()).padStart(2, '0');
      return "".concat(year, "-").concat(month, "-").concat(day, " ").concat(hour, ":").concat(minute, ":").concat(second);
    },
    resetFilter: function resetFilter() {
      this.formInline.real_name = '';
      this.formInline.mobile = '';
      this.formInline.card_code = '';
      this.formInline.start_time = '';
      this.formInline.end_time = '';
      this.formInline.type = '1,2,3,4,5,6,7,8,9,10,11,12,13,14,15,16,17,18';
      this.datenum = [];
      this.getMoneyList();
    },
    // 搜索
    handleFilter: function handleFilter() {
      var _this = this;
      this.listLoading = true;
      // 王工封装
      // type 2 为支付宝账号流水
      (0, _request.default)({
        url: "/system/shopConfig/getUserRecord/",
        method: 'put',
        data: {
          page: this.listQuery.page,
          page_size: this.listQuery.page_size,
          shop_id: this.$user.data.shop,
          type: this.formInline.type,
          mobile: this.formInline.mobile,
          real_name: this.formInline.real_name,
          card_code: this.formInline.card_code,
          start_time: this.start_time,
          end_time: this.end_time
        }
      }).then(function (response) {
        if (response.data) {
          _this.moneyList = response.data.data;
        }
        _this.listLoading = false;
      });
    },
    DownExcel: function DownExcel() {
      var _this2 = this;
      this.listLoading = true;
      // 王工封装
      // type 2 为支付宝账号流水
      (0, _request2.default)({
        url: "/system/shopConfig/getUserRecordExcel/",
        method: 'put',
        responseType: 'blob',
        // 设置响应类型为 blob
        data: {
          shop_id: this.$user.data.shop,
          type: this.formInline.type,
          mobile: this.formInline.mobile,
          real_name: this.formInline.real_name,
          card_code: this.formInline.card_code,
          start_time: this.start_time,
          end_time: this.end_time
        }
      }).then(function (response) {
        console.log(response.data, '文件');
        // if (response.data) {
        //   this.moneyList = response.data.data
        // }
        var blob = new Blob([response.data], {
          type: 'application/vnd.ms-excel'
        });
        _fileSaver.default.saveAs(blob, 'user_record.xlsx'); // 保存文件
        _this2.listLoading = false;
      });
    },
    goRisk: function goRisk() {
      var _this3 = this;
      //  this.listLoading = true
      // 王工封装
      // type 2 为支付宝账号流水
      (0, _request.default)({
        url: "/system/shopConfig/goRisk/",
        method: 'put',
        data: {
          shop_id: this.$user.data.shop,
          mobile: this.riskform.mobile,
          real_name: this.riskform.real_name,
          card_code: this.riskform.card_code
        }
      }).then(function (response) {
        // this.dialogVisiblerisk=false
        _this3.getMoneyList();
        // this.listLoading = false
      });
    },
    // 获取划扣流水——done
    getMoneyList: function getMoneyList() {
      var _this4 = this;
      this.listLoading = true;
      // 王工封装
      // type 2 为支付宝账号流水
      (0, _request.default)({
        url: "/system/shopConfig/getUserRecord/",
        method: 'put',
        data: {
          page: this.listQuery.page,
          page_size: this.listQuery.page_size,
          shop_id: this.$user.data.shop,
          type: this.formInline.type,
          mobile: this.formInline.mobile,
          real_name: this.formInline.real_name,
          card_code: this.formInline.card_code,
          start_time: this.start_time,
          end_time: this.end_time
        }
      }).then(function (response) {
        if (response.data) {
          _this4.moneyList = response.data.data;
        }
        _this4.listLoading = false;
      });
    }
  }
};